import React, { useEffect, useState } from "react";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";
import PageHeader from "../layout/PageHeader";
import AppButton from "../layout/AppButton";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Dialog from "@mui/material/Dialog";
import Skeleton from "@mui/material/Skeleton";
import Preview from "../customVisuals/Preview";
import Alert from "react-bootstrap/Alert";
import preloadimg from "../../assets/img/preloader1.gif";
import { useCustomVisuals } from "../../hooks/useCustomVisuals";

const CustomVisualSettings = () => {
  const {
    fetchAssignedGroups,
    fetchCustomVisualsV2,
    fetchSelectedVisualsV2,
    saveCustomVisualsV2,
    saveKpiStats,
  } = useCustomVisuals();

  const [validated] = useState(false);
  const [availableVisuals, setAvailableVisuals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasDuplicates, setHasDuplicates] = useState(false);

  const [previewOpen1, setPreviewOpen1] = useState(false);
  const [previewOpen2, setPreviewOpen2] = useState(false);
  const [previewOpen3, setPreviewOpen3] = useState(false);
  const [previewOpen4, setPreviewOpen4] = useState(false);

  const [previewAll, setPreviewAll] = useState(false);

  const [selectedVisual1, setSelectedVisual1] = useState("");
  const [selectedVisual2, setSelectedVisual2] = useState("");
  const [selectedVisual3, setSelectedVisual3] = useState("");
  const [selectedVisual4, setSelectedVisual4] = useState("");

  const parseVisual = (value) => (value === undefined ? null : value.split("?"));
  const urlGroupId = new URL(window.location.href).searchParams.get("groupId");

  // Groups the user is assigned to
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(true);

  const [selectedGroupId, setSelectedGroupId] = useState(urlGroupId || "");
  // Skip the picker when a groupId was already passed via URL (e.g. from Department page)
  const [groupConfirmed, setGroupConfirmed] = useState(Boolean(urlGroupId));

  const groupId = selectedGroupId;
  const selectedGroupName = assignedGroups.find((g) => g.id === selectedGroupId)?.name || "";

  useEffect(() => {
    setGroupsLoading(true);
    fetchAssignedGroups()
      .then(setAssignedGroups)
      .catch(() => setAssignedGroups([]))
      .finally(() => setGroupsLoading(false));
  }, [fetchAssignedGroups]);

  const previewBtnStyle = { padding: "5px 10px", minWidth: "unset", fontSize: "12px", lineHeight: 1.6,border:"none", color:"#d7a51c", background:"transparent", cursor:"pointer" };

  const parsedVisual1 = parseVisual(selectedVisual1);
  const parsedVisual2 = parseVisual(selectedVisual2);
  const parsedVisual3 = parseVisual(selectedVisual3);
  const parsedVisual4 = parseVisual(selectedVisual4);

  const cartItems = [];

  if (selectedVisual1 !== "") {
    const [visualName, pageName, reportId] = parsedVisual1;
    cartItems.push({ visualName, pageName, reportId });
  }
  if (selectedVisual2 !== "") {
    const [visualName, pageName, reportId] = parsedVisual2;
    cartItems.push({ visualName, pageName, reportId });
  }
  if (selectedVisual3 !== "") {
    const [visualName, pageName, reportId] = parsedVisual3;
    cartItems.push({ visualName, pageName, reportId });
  }
  if (selectedVisual4 !== "") {
    const [visualName, pageName, reportId] = parsedVisual4;
    cartItems.push({ visualName, pageName, reportId });
  }

  const reset = () => {
    cartItems.pop();
    setSelectedVisual1("");
    setSelectedVisual2("");
    setSelectedVisual3("");
    setSelectedVisual4("");
  };

  useEffect(() => {
    document.title = "Customize Visuals";
    if (!groupConfirmed || !groupId) return;
    setIsLoading(true);
    fetchCustomVisualsV2(groupId)
      .then(setAvailableVisuals)
      .catch(() => {
        setAvailableVisuals([]);
        setHasError(true);
      })
      .finally(() => setIsLoading(false));
  }, [fetchCustomVisualsV2, groupConfirmed, groupId]);

  useEffect(() => {
    if (!groupConfirmed || !groupId) return;
    fetchSelectedVisualsV2()
      .then((json) => {
        setSelectedVisual1(json[0] ?? "");
        setSelectedVisual2(json[1] ?? "");
        setSelectedVisual3(json[2] ?? "");
        setSelectedVisual4(json[3] ?? "");
      })
      .catch(() => {});
  }, [fetchSelectedVisualsV2, groupConfirmed, groupId]);

 

  const handleSubmit = (event) => {
    setIsSaving(true);
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const hasDuplicateSelection =
        (selectedVisual1 === selectedVisual2 && selectedVisual1 !== "") ||
        (selectedVisual1 === selectedVisual3 && selectedVisual1 !== "") ||
        (selectedVisual1 === selectedVisual4 && selectedVisual1 !== "") ||
        (selectedVisual2 === selectedVisual3 && selectedVisual2 !== "") ||
        (selectedVisual2 === selectedVisual4 && selectedVisual2 !== "") ||
        (selectedVisual3 === selectedVisual4 && selectedVisual3 !== "");

      if (!hasDuplicateSelection) {
        const payload = [
          {
            visuals: {
              visualGraph1: selectedVisual1.split("?"),
              visualGraph2: selectedVisual2.split("?"),
              visualGraph3: selectedVisual3.split("?"),
              visualGraph4: selectedVisual4.split("?"),
            },
          },
        ];

        saveKpiStats(payload, groupId).catch(() => {});

        saveCustomVisualsV2(payload, groupId)
          .then(() => {
            setIsSaving(false);
            setSaveSuccess(true);
            setHasError(false);
            setTimeout(() => setSaveSuccess(false), 5000);
          })
          .catch(() => {
            setIsSaving(false);
            setHasError(true);
            setTimeout(() => setHasError(false), 5000);
          });
      } else {
        setHasDuplicates(true);
        setTimeout(() => setHasDuplicates(false), 10000);
        setIsSaving(false);
      }
    }
  };

  
  
  
  return (
    <div>
      <NavHeader />
      <SideMenu />
      <div style={{position:"relative"}} id="main">
        {!groupConfirmed && (
          <div style={{ padding: "1rem", maxWidth: 480 }}>
            <PageHeader
              title={`Customize Visuals of (${selectedGroupName})`}
              subtitle="Select the persona/group you want to customize visuals for"
            />
            <Form.Group className="mb-3" controlId="groupSelect">
              <Form.Label>Select Group</Form.Label>
              <Form.Select
                value={selectedGroupId}
                onChange={(e) => setSelectedGroupId(e.target.value)}
                disabled={groupsLoading}
              >
                <option value="">
                  {groupsLoading ? "Loading groups..." : "-- Select a group --"}
                </option>
                {assignedGroups.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </Form.Select>
              {!groupsLoading && assignedGroups.length === 0 && (
                <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 8 }}>
                  No assigned groups found. Please contact your administrator.
                </p>
              )}
            </Form.Group>
            <AppButton
              variant="primary"
              disabled={!selectedGroupId || groupsLoading}
              onClick={() => setGroupConfirmed(true)}
              style={{ marginTop: "1rem", color: "white" }}
            >
              Continue
            </AppButton>
          </div>
        )}

        {groupConfirmed && isLoading && (
          <div style={{ padding: "1rem" }}>
            <Skeleton variant="text" width={220} height={40} />
            <Skeleton variant="text" width={340} height={20} sx={{ mb: 2 }} />
            <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: "1.5rem" }}>
              {[1, 2, 3, 4].map((i) => (
                <div key={i} style={{ flex: "1 1 30%", minWidth: 220 }}>
                  <Skeleton variant="text" width={80} height={24} />
                  <Skeleton variant="rounded" height={38} />
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: "10px", marginTop: "3rem" }}>
              <Skeleton variant="rounded" width={100} height={40} />
              <Skeleton variant="rounded" width={100} height={40} />
            </div>
          </div>
        )}

        {groupConfirmed && !isLoading && (
          <div>
            <div style={{ padding: "1rem", width: "auto", height: "auto" }}>
              <PageHeader
                title={`Customize Visuals of (${selectedGroupName})`}
                subtitle="Choose up to four visuals to display on your Home page"
                onBack={() => setGroupConfirmed(false)}
              />
              <Form style={{marginTop:"20px"}} noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="4"
                    style={{ position: "relative" }}
                    controlId="validationCustom02"
                  >
                    <Form.Label>Visual 1</Form.Label>
                    {selectedVisual1 !== "" && (
                      <Form.Group as={Col} md="2" style={{ marginTop: "-36px" }} className="previewBtn" controlId="previewBtn1">
                        <AppButton variant="outline" onClick={() => setPreviewOpen1(!previewOpen1)} style={previewBtnStyle}>Preview</AppButton>
                      </Form.Group>
                    )}
                    <Form.Select value={selectedVisual1} onChange={(e) => setSelectedVisual1(e.target.value)}>
                      <option value=""> Select Visual</option>
                      {availableVisuals.map((item, index) => (
                        <option key={index} value={`${item.visualName}?${item.reportName}?${item.reportId}`} style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="4"
                    style={{ position: "relative" }}
                    controlId="validationCustom04"
                  >
                    <Form.Label>Visual 2</Form.Label>
                    {selectedVisual2 !== "" && (
                      <Form.Group as={Col} md="2" style={{ marginTop: "-36px" }} className="previewBtn" controlId="previewBtn2">
                        <AppButton variant="outline" onClick={() => setPreviewOpen2(!previewOpen2)} style={previewBtnStyle}>Preview</AppButton>
                      </Form.Group>
                    )}
                    <Form.Select value={selectedVisual2} onChange={(e) => setSelectedVisual2(e.target.value)}>
                      <option value=""> Select Visual</option>
                      {availableVisuals.map((item, index) => (
                        <option key={index} value={`${item.visualName}?${item.reportName}?${item.reportId}`} style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="4"
                    style={{ position: "relative" }}
                    controlId="validationCustom06"
                  >
                    <Form.Label>Visual 3</Form.Label>
                    {selectedVisual3 !== "" && (
                      <Form.Group as={Col} md="2" style={{ marginTop: "-36px" }} className="previewBtn" controlId="previewBtn3">
                        <AppButton variant="outline" onClick={() => setPreviewOpen3(!previewOpen3)} style={previewBtnStyle}>Preview</AppButton>
                      </Form.Group>
                    )}
                    <Form.Select value={selectedVisual3} onChange={(e) => setSelectedVisual3(e.target.value)}>
                      <option value=""> Select Visual</option>
                      {availableVisuals.map((item, index) => (
                        <option key={index} value={`${item.visualName}?${item.reportName}?${item.reportId}`} style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="4"
                    style={{ position: "relative" }}
                    controlId="validationCustom08"
                  >
                    <Form.Label>Visual 4</Form.Label>
                    {selectedVisual4 !== "" && (
                      <Form.Group as={Col} md="2" style={{ marginTop: "-36px" }} className="previewBtn" controlId="previewBtn4">
                        <AppButton variant="outline" onClick={() => setPreviewOpen4(!previewOpen4)} style={previewBtnStyle}>Preview</AppButton>
                      </Form.Group>
                    )}
                    <Form.Select value={selectedVisual4} onChange={(e) => setSelectedVisual4(e.target.value)}>
                      <option value=""> Select Visual</option>
                      {availableVisuals.map((item, index) => (
                        <option key={index} value={`${item.visualName}?${item.reportName}?${item.reportId}`} style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>

                <div
                  style={{
                    gridGap: "10px",
                    display: "flex",
                    marginTop: "3rem",
                  }}
                  className="mb-3"
                >
                  <AppButton variant="primary" type="submit" style={{color:"white"}}>
                    Save Visuals for ({selectedGroupName})
                  </AppButton>

                  {cartItems.length !== 0 && (
                    <AppButton variant="secondary" onClick={() => setPreviewAll(!previewAll)} style={{height:"40px"}}>
                      Preview All
                    </AppButton>
                  )}

                  <AppButton variant="secondary" type="reset" onClick={reset} style={{height:"40px"}}>
                    Clear all
                  </AppButton>
                </div>
              </Form>
            </div>

            <Dialog className="modelHomeCustomize" open={previewOpen1} onClose={() => setPreviewOpen1(!previewOpen1)} aria-labelledby="preview-dialog-1">
              <div style={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.6)", height: "420px", padding: "1rem", borderRadius: "6px", border: "4px solid #eee", width: "99%", paddingBottom: "5rem" }}>
                <Preview report_id={parsedVisual1[2]} report_name={parsedVisual1[1]} visuals_id={parsedVisual1[0]} title="" />
              </div>
            </Dialog>

            <Dialog className="modelHomeCustomize" open={previewOpen2} onClose={() => setPreviewOpen2(!previewOpen2)} aria-labelledby="preview-dialog-2">
              <div style={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.6)", height: "420px", padding: "1rem", borderRadius: "6px", border: "4px solid #eee", width: "99%", paddingBottom: "5rem" }}>
                <Preview report_id={parsedVisual2[2]} report_name={parsedVisual2[1]} visuals_id={parsedVisual2[0]} title="" />
              </div>
            </Dialog>

            <Dialog className="modelHomeCustomize" open={previewOpen3} onClose={() => setPreviewOpen3(!previewOpen3)} aria-labelledby="preview-dialog-3">
              <div style={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.6)", height: "420px", padding: "1rem", borderRadius: "6px", border: "4px solid #eee", width: "99%", paddingBottom: "5rem" }}>
                <Preview report_id={parsedVisual3[2]} report_name={parsedVisual3[1]} visuals_id={parsedVisual3[0]} title="" />
              </div>
            </Dialog>

            <Dialog className="modelHomeCustomize" open={previewOpen4} onClose={() => setPreviewOpen4(!previewOpen4)} aria-labelledby="preview-dialog-4">
              <div style={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.6)", height: "420px", padding: "1rem", borderRadius: "6px", border: "4px solid #eee", width: "99%", paddingBottom: "5rem" }}>
                <Preview report_id={parsedVisual4[2]} report_name={parsedVisual4[1]} visuals_id={parsedVisual4[0]} title="" />
              </div>
            </Dialog>

            <Dialog className="modelHomeCustomize2" open={previewAll} onClose={() => setPreviewAll(!previewAll)} aria-labelledby="preview-all-dialog">
              <div className="modelHomeCustomize1">
                {cartItems.map((item, index) => (
                  <div key={index} style={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.6)", height: "420px", padding: "1rem", borderRadius: "6px", border: "4px solid #eee", width: "99%", paddingBottom: "5rem" }}>
                    <Preview report_id={item.reportId} visuals_id={item.visualName} report_name={item.pageName} title="" />
                  </div>
                ))}
              </div>
            </Dialog>
          </div>
        )}

      {saveSuccess && (
          <div>
            <Alert style={{ position: "absolute", right: "20px", top: "10px" }} variant="success">
              <p className="mb-0">Custom Visuals Saved Successfully</p>
            </Alert>
          </div>
        )}

      {hasError && (
          <div>
            <Alert style={{ position: "absolute", right: "20px", top: "10px" }} variant="danger">
              <p className="mb-0">Something Went wrong, Please try again after sometime</p>
            </Alert>
          </div>
        )}

        {isSaving && (
          <div style={{position:"fixed",background:"rgba(0,0,0,0.8)",width:"100%",height:"100%",top:"0",left:"0",right:"0",bottom:"0",display:"grid",justifyContent:"center",alignItems:"center",color:"white",zIndex:"99999",justifyItems:"center",alignContent:"center"}}>
            <img width={200} src={preloadimg} alt="Loading" />
            <span>Saving your visuals...</span>
          </div>
        )}

      {hasDuplicates && (
          <div>
            <Alert style={{ position: "absolute", right: "20px", top: "10px" }} variant="danger">
              <p className="mb-0">Duplicate visuals selected!</p>
            </Alert>
          </div>
        )}



      </div>
    </div>
  );
};

export default CustomVisualSettings;
